<template>
  <div>
    <a-dropdown :trigger="['click']">
      <span class="edit-status">
        <a-tag :color="testPlanStatus[status].color">{{ testPlanStatus[status].label }}</a-tag>
        <a-icon class="icon-down" type="down" />
      </span>
      <a-menu slot="overlay">
        <a-menu-item v-for="(item, index) in nextStatus" :key="index" v-tc="{ name: '更新状态', label: testPlanStatus[item.node_id].label }" @click="onChange(item.node_id)">
          <a-tag :color="testPlanStatus[item.node_id].color">{{ testPlanStatus[item.node_id].label }}</a-tag>
        </a-menu-item>
      </a-menu>
    </a-dropdown>
  </div>
</template>

<script>
import { testPlanStatus } from '@/utils/dictionary';
import { testPlanUpdateStatus } from '@/api/project/testPlan';

export default {
  name: 'TestPlanStatusEdit',
  props: {
    status: {
      type: [String, Number],
      default: null
    },
    nextStatus: {
      type: Array,
      default: () => {
        return [];
      }
    },
    planId: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      testPlanStatus,
      projectId: parseInt(this.$route.params.project_id) || null
    };
  },
  methods: {
    onChange(value) {
      testPlanUpdateStatus({ test_plan_id: this.planId, status: value }).then(() => {
        this.$message.success('状态更新成功');
        this.$emit('change');
      });
    }
  }
};
</script>

<style lang="less" scoped>
.edit-status {
  cursor: pointer;
  display: inline-block;
  padding: 0 4px;
  line-height: 22px;

  .icon-down {
    opacity: 0;
  }
}

.edit-status:hover {
  cursor: pointer;
  background-color: #e4e4e4;

  .icon-down {
    opacity: 1;
  }
}
</style>
